// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f59bea65","453":"27b74e50","455":"7aae0f55","977":"14c54acf"}[chunkId] + ".chunk.js";
};